import { Helmet } from 'react-helmet-async';
import { SEO } from '../../../utils/seo';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import UnderstandingHoardingSection from './components/UnderstandingHoardingSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import NoCleanupRequiredSection from './components/NoCleanupRequiredSection';
import ProcessSection from './components/ProcessSection';
import ChallengesSection from './components/ChallengesSection';
import BenefitsSection from './components/BenefitsSection';
import SafetyHealthSection from './components/SafetyHealthSection';
import EmotionalSupportSection from './components/EmotionalSupportSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import ComparisonSection from './components/ComparisonSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '../../../components/feature/Footer';

export default function SellHoarderHousesPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Sell Hoarder House El Paso | No Cleanup Needed | TREX RE LLC"
        description="Sell your hoarder house as-is with no cleanup required. We buy homes filled with junk, clutter, or non-livable conditions fast. Get a fair cash offer today from TREX RE LLC."
        keywords="sell hoarder house El Paso, buy hoarder homes, no cleanup needed, sell cluttered house, junk filled house, non-livable property"
        canonical="/sell-hoarder-houses"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Hoarder House Buying Service",
          "provider": {
            "@type": "RealEstateAgent",
            "name": "TREX RE LLC"
          },
          "areaServed": "El Paso, TX"
        }}
      />
      <Navbar />
      <HeroSection />
      <IntroSection />
      <UnderstandingHoardingSection />
      <WhyChooseUsSection />
      <NoCleanupRequiredSection />
      <ProcessSection />
      <ChallengesSection />
      <BenefitsSection />
      <SafetyHealthSection />
      <EmotionalSupportSection />
      <CaseStudiesSection />
      <ComparisonSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
